<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="items"
      :acesso-disable="acessoDisable"
      :footer-props="{
        'items-per-page-text':'Linhas por página',
        'page-text': '{0}-{1} de {2}',
        'items-per-page-all-text': 'Todos',
      }"
    >
      <template v-slot:no-data>
        Sem dados
      </template>

      <template #item.nome="{ item }">
        <router-link
          :to="{ name: 'colaborador', params: { id: item.id } }"
          class="text--primary font-weight-semibold text-truncate cursor-pointer text-decoration-none"
        >
          <div class="d-flex align-center">
            <v-avatar
              :color="`${$vuetify.theme.dark ? 'primary' : '#DCDCDC'}`"
              size="32"
            >
              <span
                :class="`${$vuetify.theme.dark ? 'white--text' : 'primary--text'} font-weight-bold`"
              >
                {{ item.nome.toUpperCase().charAt(0) }}{{ item.sobrenome ? item.sobrenome.toUpperCase().charAt(0) : '' }}
              </span>
            </v-avatar>
            <div class="d-flex flex-column ms-3">
              {{ item.nome }} {{ item.sobrenome }}
              <small>@{{ item.nome }}</small>
            </div>
          </div>
        </router-link>
      </template>

      <template #item.cargoNome="{ item }">
        {{ item.cargoNome }}
      </template>

      <template #item.departamentoNome="{ item }">
        {{ item.departamentoNome }}
      </template>

      <template #item.perfilNome="{ item }">
        {{ item.perfilNome || '-' }}
      </template>

      <template #item.atuacaoNome="{ item }">
        {{ item.atuacaoNome }}
      </template>

      <template #item.ativo="{ item }">
        <v-chip
          v-if="item.bloqueado"
          class="v-chip-light-bg font-weight-semibold text-capitalize error--text"
          small
          color="error"
        >
          <v-icon
            left
            small
            class="error--text"
          >
            {{ icons.mdiLock }}
          </v-icon>
          Bloqueado
        </v-chip>

        <v-chip
          v-else
          class="v-chip-light-bg font-weight-semibold text-capitalize"
          small
          :class="`${item.ativo ? 'success--text' : 'secondary--text'}`"
          :color="`${item.ativo ? 'success' : 'secondary'}`"
        >
          {{ item.ativo ? 'Ativo' : 'Inativo' }}
        </v-chip>
      </template>

      <template #item.actions="{ item }">
        <v-menu
          bottom
          left
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-bind="attrs"
              class="ml-n5"
              v-on="on"
              color="primary"
              @click="ativarOuInativarItem(item)"
            >
              <v-icon>{{ icons.mdiDotsVertical }}</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-item v-if="acessoDisable && !item.bloqueado">
              <v-list-item-title
                role="button"
                @click="openDialogAtivarOuInativarItem"
              >
                <v-icon
                  size="20"
                  class="mr-1"
                >
                  {{ item.ativo ? icons.mdiCloseThick : icons.mdiCheckBold }}
                </v-icon>
                <span class="text-capitalize">{{ item.ativo ? 'Inativar' : 'Ativar' }}</span>
              </v-list-item-title>
            </v-list-item>

            <v-list-item v-if="acessoDisable && item.bloqueado">
              <v-list-item-title
                role="button"
                @click="openDialogDesbloquear"
              >
                <v-icon
                  size="20"
                  class="mr-1"
                  color="error"
                >
                  {{ icons.mdiLockOpenVariant }}
                </v-icon>
                <span class="error--text font-weight-bold">Desbloquear Conta</span>
              </v-list-item-title>
            </v-list-item>

            <v-list-item v-if="acessoDisable && item.ativo && !item.bloqueado">
              <v-list-item-title
                role="button"
                @click="openDialogBloquear"
              >
                <v-icon
                  size="20"
                  class="mr-1"
                  color="error"
                >
                  {{ icons.mdiLock }}
                </v-icon>
                <span class="error--text font-weight-bold">Bloquear Conta</span>
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-data-table>

    <v-dialog
      v-model="dialogAtivarOuInativarItem"
      max-width="500px"
      persistent
    >
      <v-card>
        <v-card-title class="headline text-capitalize">
          {{ isColaboradorAtivoMensagem }}
        </v-card-title>
        <v-card-text>
          {{ `Tem certeza que vai ${isColaboradorAtivoMensagem} este colaborador?` }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            outlined
            @click="closeDialogAtivarOuInativarItem"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            @click="confirmarAtivacaoOuInativacaoItem"
          >
            <v-progress-circular
              v-if="loading"
              indeterminate
              color="secundary"
            ></v-progress-circular>
            <span v-else>OK</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogDesbloquear"
      max-width="500px"
      persistent
    >
      <v-card>
        <v-card-title class="headline">
          Desbloquear Colaborador
        </v-card-title>
        <v-card-text>
          Ao confirmar, as tentativas de login falhas serão zeradas e o bloqueio temporário será removido imediatamente.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            outlined
            @click="closeDialogDesbloquear"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            @click="confirmarDesbloqueio"
          >
            <v-progress-circular
              v-if="loading"
              indeterminate
              color="white"
              size="20"
            ></v-progress-circular>
            <span v-else>Confirmar</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogBloquear"
      max-width="500px"
      persistent
    >
      <v-card>
        <v-card-title class="headline">
          Bloquear Colaborador
        </v-card-title>
        <v-card-text>
          Ao confirmar, o colaborador não conseguirá mais fazer login até que a conta seja desbloqueada. O cadastro, equipes, filas, cargo e perfil não serão alterados.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            outlined
            @click="closeDialogBloquear"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            @click="confirmarBloqueio"
          >
            <v-progress-circular
              v-if="loading"
              indeterminate
              color="white"
              size="20"
            ></v-progress-circular>
            <span v-else>Confirmar</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// 1. ADICIONADO: Import mdiLock
import { mdiCheckBold, mdiCloseThick, mdiDotsVertical, mdiLockOpenVariant, mdiLock } from '@mdi/js'
import { ref } from '@vue/composition-api'
import ColaboradorService from '@/services/modules/ColaboradorService'

export default {
  props: {
    items: { type: Array, default: () => {} },
    acessoDisable: { type: Boolean, default: () => true },
  },

  setup(props, { emit }) {
    const headers = [
      { text: 'NOME', value: 'nome' },
      { text: 'LOGIN', value: 'login' },
      { text: 'ATUAÇÃO', value: 'atuacaoNome' },
      { text: 'DEPARTAMENTO', value: 'departamentoNome' },
      { text: 'CARGO', value: 'cargoNome' },
      { text: 'PERFIL', value: 'perfilNome' },
      { text: 'STATUS', value: 'ativo' }, // A coluna 'ativo' agora renderiza o bloqueio também
      { text: 'OPÇÔES', value: 'actions', align: 'center' },
    ]

    const dialogAtivarOuInativarItem = ref(false)
    const loading = ref(false)
    const colaboradorId = ref(0)
    const isColaboradorAtivo = ref(undefined)
    const isColaboradorAtivoMensagem = ref('')
    const dialogDesbloquear = ref(false)
    const dialogBloquear = ref(false)

    // Ao clicar nos 3 pontinhos, essa função já salva o ID e o Status
    const ativarOuInativarItem = item => {
      colaboradorId.value = item.id
      isColaboradorAtivo.value = item.ativo
      isColaboradorAtivoMensagem.value = item.ativo ? 'inativar' : 'ativar'
    }

    const openDialogAtivarOuInativarItem = () => { dialogAtivarOuInativarItem.value = true }
    const closeDialogAtivarOuInativarItem = () => { dialogAtivarOuInativarItem.value = false }

    const openDialogDesbloquear = () => { dialogDesbloquear.value = true }
    const closeDialogDesbloquear = () => { dialogDesbloquear.value = false }

    const confirmarDesbloqueio = () => {
      loading.value = true
      ColaboradorService.desbloquear(colaboradorId.value)
        .then(() => {
          emit('confirmar-inativacao')
        })
        .finally(() => {
          loading.value = false
          closeDialogDesbloquear()
        })
    }

    const openDialogBloquear = () => { dialogBloquear.value = true }
    const closeDialogBloquear = () => { dialogBloquear.value = false }

    const confirmarBloqueio = () => {
      loading.value = true
      ColaboradorService.bloquear(colaboradorId.value)
        .then(() => {
          emit('confirmar-inativacao')
        })
        .finally(() => {
          loading.value = false
          closeDialogBloquear()
        })
    }

    const confirmarAtivacaoOuInativacaoItem = () => {
      loading.value = true
      ColaboradorService
        .ativarOuInativar(colaboradorId.value, { ativar: !isColaboradorAtivo.value })
        .then(() => {
          emit('confirmar-inativacao')
        })
        .finally(() => {
          closeDialogAtivarOuInativarItem()
          loading.value = false
        })
    }

    return {
      dialogAtivarOuInativarItem,
      loading,
      isColaboradorAtivo,
      isColaboradorAtivoMensagem,
      ativarOuInativarItem,
      openDialogAtivarOuInativarItem,
      closeDialogAtivarOuInativarItem,
      confirmarAtivacaoOuInativacaoItem,

      dialogDesbloquear,
      openDialogDesbloquear,
      closeDialogDesbloquear,
      confirmarDesbloqueio,

      dialogBloquear,
      openDialogBloquear,
      closeDialogBloquear,
      confirmarBloqueio,

      icons: {
        mdiCheckBold,
        mdiCloseThick,
        mdiDotsVertical,
        mdiLockOpenVariant,
        mdiLock, // 2. ADICIONADO: Retorno do ícone
      },
      headers,
    }
  },
}
</script>
